import React, { useMemo, useCallback } from 'react';
import {
  getIn,
  ErrorMessage,
} from 'formik';

import {
  Flex,
} from 'web-styled';

import {
  TextInput,
} from 'web-components';

import * as S from './styled';

import { InputProps, TextFieldDefaultProps } from './TextField';

const TimeTextField = ({
  label,
  labelWeight,
  field,
  form: {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  },
  flex,
  width,
  color,
  margin,
  spacing,
  className,
}: InputProps) => {
  const error = getIn(errors, field.name);
  const touch = getIn(touched, field.name);

  const [mins, secs] = useMemo(() => {
    const mind = (field.value || '') % (60 * 60);
    const m = Math.floor(mind / 60);
    const s = Math.ceil(mind % 60);

    return [m, s];
  }, [field.value]);

  const onChangeMin = useCallback(({ target }) => {
    const newMins = parseInt(target.value || 0, 10);
    const value = (newMins * 60) + secs;
    setFieldValue(field.name, value);
  }, [field.value, field.name]);

  const onChangeSec = useCallback(({ target }) => {
    const newSecs = parseInt(target.value || 0, 10);
    const value = (mins * 60) + newSecs;
    setFieldValue(field.name, value);
  }, [field.value, field.name]);

  return (
    <Flex
      column
      flex={flex}
      width={width}
      margin={margin}
      spacing={spacing}
      className={className}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
          weight={labelWeight}
        >
          {label}
        </S.Label>
      )}
      <S.TimeInputWraper hasError={touch && error}>
        <TextInput
          id={`${field.name}-min`}
          type="text"
          placeholder="00"
          onChange={onChangeMin}
          onBlur={() => {
            setFieldTouched(field.name);
          }}
        />
        <span>:</span>
        <TextInput
          id={`${field.name}-sec`}
          type="text"
          placeholder="00"
          onChange={onChangeSec}
          onBlur={() => {
            setFieldTouched(field.name);
          }}
        />
      </S.TimeInputWraper>
      <ErrorMessage
        name={field.name}
        component={S.Error}
      />
    </Flex>
  );
};

TimeTextField.defaultProps = TextFieldDefaultProps;

export default TimeTextField;
